module.exports = "//public.zight.com/packs/media/images/icons-support-eacb6e4f7223ec7a181820077326ae47.svg";